import axios from 'axios';
import { showFailToast, showToast } from 'vant';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import md5 from 'crypto-js/md5';
import store from '@/store';
import envConfig from '@/config';
import { API_LANGS } from '@/constants';
import { getCustomAgent } from '@/utils';
import { randomUUID } from 'cfmoto-utils';

function decodeDataComponent(request = {}) {
  try {
    if ([null, undefined, ''].some((val) => val === request.data) || request.data instanceof FormData) return '';
    if (['GET', 'DELETE'].some((val) => val === request.method.toUpperCase()) && Object.keys(request.data).length < 1) return '';
    if (typeof data === 'string') return decodeURIComponent(request.data);
    return decodeURIComponent(JSON.stringify(request.data));
  } catch (e) {
    if (/URI malformed/.test(e.message)) return JSON.stringify(request.data);
    return '';
  }
}

function getQuery(params) {
  const newParams = params ? {} : null;
  Object.keys(params || {}).map((key) => {
    if (!params) return;
    if (params[key] !== undefined && params[key] !== null) {
      newParams[key] = params[key];
    }
  });
  return newParams && Object.keys(newParams).length > 0 ? qs.stringify(newParams, { arrayFormat: 'repeat', encode: false }) : '';
}

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
const instance = axios.create({
  baseURL,
  timeout: 30000,
  paramsSerializer(params) {
    // 'indices' | 'brackets' | 'repeat' | 'comma' |
    return qs.stringify(params, { arrayFormat: 'repeat', encode: false });
  },
  // transformRequest: [
  //   (data, data2) => {
  //     console.log(data, data2);
  //     return data;
  //   },
  // ],
});

// 加签
instance.interceptors.request.use((request) => {
  console.log(request);
  console.log(Object.keys({ id: 3, iconUrl: 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com/IMD/social/Icon/ic_hnl3.png', content: '发帖子分享骑行经历', type: 2, activeFlag: true, abledFlag: true }).sort());
  const appConfig = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_CONFIG`];
  const query = getQuery(request.params);
  const data = decodeDataComponent(request);
  const queryError = /error/.test(window.location.href) ? '&error=' + new Date().getTime() : '';
  const nonce = randomUUID();
  const timestamp = new Date().getTime();
  const signature = `${query}${queryError}${data}appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}${appConfig.appSecret}`;
  const signatureMd5 = md5(sha1(signature).toString()).toString();
  const signatureParam = `appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}`;

  console.log(`=====  加签 ${request.url} =====`);
  const signatureDataStr = JSON.stringify({ query, data, nonce, timestamp, signature, signatureMd5, signatureParam });
  console.log(`signatureDataStr:${signatureDataStr}`);
  console.log(`=====  加签end =====`);

  request.headers['Cfmoto-X-Sign'] = `${signatureMd5}`;
  request.headers['Cfmoto-X-Sign-Type'] = `0`;
  request.headers['Cfmoto-X-Param'] = `${signatureParam}`;
  return request;
});

if (envConfig.env === 'development') {
  instance.interceptors.request.use((request) => request);
  instance.interceptors.response.use((response) => {
    /* eslint-disable no-console */
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

// 拦截器
instance.interceptors.request.use(
  async (request) => {
    console.log(request);

    if (window.cfmoto.isNativeEnv && window.cfmoto.existFunction('getCountry')) {
      const areaNo = store.state.areaConfig.areaNo;
      console.log('areaNo:' + areaNo);
      const items = store.state.areaConfig.items;
      console.log('items:', items);
      const { domain } = items.find((item) => item.areaNo === areaNo) || {};
      console.log('domain:', domain);
      request.baseURL = domain ? `https://${domain}/v1.0` : request.baseURL;
    }

    const token = JSON.parse(localStorage.getItem('token') || '""');
    const Authorization = !token || /^Bearer/.test(token) ? token : `Bearer ${token}`;
    const lang = JSON.parse(localStorage.getItem('language') || '"zh"').split(/[-_]/)[0];
    const { userId } = store.state.user.userInfo;

    request.params = request.params || {};
    request.data = request.data || {};
    request.withCredentials = true;
    request.headers['Authorization'] = Authorization || 'YyPhuktDZtOnnaWlOepyBheBWRzWQI3';
    request.headers['Cfmoto-User-Agent'] = getCustomAgent();

    if (userId) {
      request.headers['user_id'] = userId;
    }
    if (!request.headers['lang']) {
      request.headers['lang'] = API_LANGS[lang];
    }
    request.headers['version'] = envConfig.version;

    console.log(request);
    return request;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    // 阻止options
    if (response.status === 200 && response.config.method.toLowerCase() === 'options') return false;
    const { to } = response.config;
    const meta = (to || {}).meta || {};

    if (response.status !== 200) {
      return Promise.reject(response);
    }
    // 处理格式异常
    /* eslint-disable no-param-reassign */
    if (response.data.data === '{}') {
      response.data.data = JSON.parse(response.data.data);
    }

    /* eslint-enable */
    // 当前商品需登录才能查看 (-8)
    if ([-8].some((code) => code === response.data.code)) {
      localStorage.removeItem('token');
      // 无需登录
      if (meta.auth === 0) {
        return Promise.resolve(response.data);
      }
      // 缺少access_token参数
      if (response.data.code === 41001) {
        showFailToast(instance.i18n.global.t('cfmoto.pleaseLoginFirst'));
      }
      // 未登录
      // if (response.data.code === 41002) {
      //   showFailToast('登录失效，请重新登录！');
      // }
      // 重新登录
      if (response.data.code === 41002) {
        showFailToast(instance.i18n.global.t('cfmoto.pleaseLoginFirst'));
      }
      // 未知的登录用户
      if (response.data.code === 10022) {
        showFailToast(instance.i18n.global.t('cfmoto.pleaseLoginFirst'));
      }
      // 取页面拦截器里to.fullPath或loction.href
      // const { protocol, host, pathname, search } = window.location;
      // const fullPath = to ? `${to.fullPath}` : `${pathname}${search}`;
      // const redirectUri = `${protocol}//${host}${fullPath}`;
      // if (to && to.meta.auth === 2) {
      //   // 微信授权
      //   window.location.replace(`${window.location.protocol}${authURL}/Wxauth/index?redirect_uri=${encodeURIComponent(redirectUri)}`);
      // } else {
      //   setTimeout(() => {
      //     router.push({ name: 'user-login', query: { redirectUri: fullPath } });
      //   }, 500);
      // }
      // http:// ams.ibuycoinhd.com/H5/Wxauth/index/redirect_uri/http://ams.ibuycoinhd.com/ibuy/home
      setTimeout(() => {
        // if (Vue.isApp) {
        //   const appData = { name: 'UserLogin', params: {} };
        //   const origin = `${window.location.protocol}//${window.location.host}`;
        //   if (window.ReactNativeWebView) return window.ReactNativeWebView.postMessage(JSON.stringify(appData));
        //   return window.postMessage(JSON.stringify(appData), origin);
        // }
        // return window.location.replace(`${window.location.protocol}${authURL}/Wxauth/index?redirect_uri=${encodeURIComponent(redirectUri)}`);
      }, 1000);
    } else {
      return Promise.resolve(response.data);
    }

    return Promise.reject(response.data);
  },
  (error) => {
    console.log('=========   error');
    console.log(error);
    console.log(instance.i18n);
    console.log(instance.i18n.global.t('cfmoto.noContent'));
    if (error.message.indexOf('Network Error') > -1) {
      showFailToast(instance.i18n.global.t('cfmoto.networkException'));
    } else if (error.message.indexOf('code 401') > -1) {
      const { to } = error.config;
      const meta = (to || {}).meta || {};
      window.localStorage.removeItem('token');
      if (meta.auth === 0) return Promise.resolve(error.response);
      console.log('登录失效');
      const isApp = (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
      console.log(isApp);
      console.log(window.cfmoto);
      if (isApp) {
        window.cfmoto.redirectTo({ url: 'LoginPage' });
      } else {
        showToast(instance.i18n.global.t('cfmoto.pleaseLoginFirst'));
      }
    } else if (error.message.indexOf('code 404') > -1) {
      showFailToast(instance.i18n.global.t('cfmoto.noContent'));
    } else if (error.message.indexOf('timeout of') > -1) {
      showFailToast(instance.i18n.global.t('cfmoto.requestTimedOut'));
    } else if (error.message.indexOf('430') > -1) {
      showFailToast(error.message);
      return Promise.reject(error);
    } else {
      showFailToast(instance.i18n.global.t('cfmoto.systemBusy'));
    }
    return Promise.reject(error);
  }
);

instance.useRouter = function useRouter(router) {
  instance.router = router;
  return instance;
};

instance.useStore = function useStore(store) {
  instance.store = store;
  return instance;
};

instance.useI18n = function useI18n(i18n) {
  instance.i18n = i18n;
  return instance;
};

export default instance;
